import React from 'react';

const DisputeForm = ({
  disputeReason,
  setDisputeReason,
  disputeDescription,
  setDisputeDescription,
  onDisputeCompletion,
  onCancel,
  loading
}) => {
  return (
    <div className="mt-4 p-4 bg-red-50 rounded-lg border border-red-200">
      <h5 className="font-semibold mb-3 text-red-700">Open a Dispute</h5>
      <p className="text-sm text-gray-600 mb-4">
        Opening a dispute will hold the payment and allow you to communicate with the provider to resolve the issue.
      </p>
      
      <div className="mb-3">
        <label className="block text-sm font-medium text-gray-700 mb-1">Reason for Dispute</label>
        <select
          value={disputeReason}
          onChange={(e) => setDisputeReason(e.target.value)}
          className="w-full px-3 py-2 border border-red-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
          data-testid="dispute-reason-select"
        >
          <option value="">Select a reason...</option>
          <option value="Work not completed">Work not completed</option>
          <option value="Poor quality work">Poor quality work</option>
          <option value="Work different from agreed">Work different from agreed</option>
          <option value="Provider did not show up">Provider did not show up</option>
          <option value="Incomplete work">Incomplete work</option>
          <option value="Other">Other</option>
        </select>
      </div>
      
      <div className="mb-3">
        <label className="block text-sm font-medium text-gray-700 mb-1">Detailed Description</label>
        <textarea
          value={disputeDescription}
          onChange={(e) => setDisputeDescription(e.target.value)}
          placeholder="Describe in detail what went wrong and what you expected..."
          rows="3"
          className="w-full px-3 py-2 border border-red-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
          data-testid="dispute-description"
        />
      </div>
      
      <div className="flex gap-2">
        <button
          onClick={onDisputeCompletion}
          disabled={loading || !disputeReason.trim() || !disputeDescription.trim()}
          className="flex-1 bg-red-600 text-white py-2 rounded-lg hover:bg-red-700 font-semibold disabled:opacity-50"
          data-testid="dispute-btn"
        >
          {loading ? 'Opening Dispute...' : 'Open Dispute'}
        </button>
        <button
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default DisputeForm;
